<div class="row">
  <div class="col-12">
    <div class="header">
      <p>{{ 'LlmSettings.PageIntro' | localize }}</p>
    </div>

    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'LlmSettings.Loading' | localize }}</p>
    </div>

    <form [formGroup]="settingsForm" (ngSubmit)="saveSettings()" *ngIf="!loading">
      <mat-card class="cardWithShadow">
        <mat-card-content>
          <mat-card-header>
            <mat-card-title>{{ 'LlmSettings.WelcomeMessages' | localize }}</mat-card-title>
            <mat-card-subtitle class="p-b-4">{{ 'LlmSettings.WelcomeMessagesDescription' | localize }}</mat-card-subtitle>
          </mat-card-header>

          <div class="row">
            <div class="col-md-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'LlmSettings.DefaultWelcomeMessage' | localize }}</mat-label>
                <textarea matInput formControlName="welcomeMessageDefault" rows="3"></textarea>
              </mat-form-field>
            </div>

            <div class="col-md-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'LlmSettings.ChatBotWelcomeMessage' | localize }}</mat-label>
                <textarea matInput formControlName="welcomeMessageChatBotUi" rows="3"></textarea>
                <mat-error *ngIf="settingsForm.get('welcomeMessageChatBotUi')?.hasError('required')">
                  {{ 'LlmSettings.ChatBotWelcomeMessageRequired' | localize }}
                </mat-error>
                <mat-error *ngIf="settingsForm.get('welcomeMessageChatBotUi')?.hasError('whitespace')">
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'LlmSettings.ChatWidgetWelcomeMessage' | localize }}</mat-label>
                <textarea matInput formControlName="welcomeMessageChatWidget" rows="3"></textarea>
                <mat-error *ngIf="settingsForm.get('welcomeMessageChatWidget')?.hasError('required')">
                  {{ 'LlmSettings.ChatWidgetWelcomeMessageRequired' | localize }}
                </mat-error>
                <mat-error *ngIf="settingsForm.get('welcomeMessageChatWidget')?.hasError('whitespace')">
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="cardWithShadow mt-4">
        <mat-card-content>
          <mat-card-header>
            <mat-card-title>{{ 'LlmSettings.UnansweredQuestionsMessage' | localize }}</mat-card-title>
            <mat-card-subtitle>{{ 'LlmSettings.UnansweredQuestionsMessageDescription' | localize }}</mat-card-subtitle>
          </mat-card-header>

          <div class="row">
            <div class="col-md-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'LlmSettings.UnansweredQuestionsMessage' | localize }}</mat-label>
                <textarea matInput formControlName="unansweredQuestionMessage" rows="3" placeholder="{{ 'LlmSettings.UnansweredQuestionsMessagePlaceholder' | localize }}"></textarea>
                <mat-error *ngIf="settingsForm.get('unansweredQuestionMessage')?.hasError('required')">
                  {{ 'LlmSettings.UnansweredQuestionsMessageRequired' | localize }}
                </mat-error>
                <mat-error *ngIf="settingsForm.get('unansweredQuestionMessage')?.hasError('whitespace')">
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="cardWithShadow mt-4">
        <mat-card-content>
          <mat-card-header>
            <mat-card-title>{{ 'LlmSettings.GeneralKnowledgeManagement' | localize }}</mat-card-title>
            <mat-card-subtitle>{{ 'LlmSettings.GeneralKnowledgeManagementDescription' | localize }}</mat-card-subtitle>
          </mat-card-header>

          <div class="row">
            <div class="col-md-12 mb-3">
              <mat-slide-toggle formControlName="allowGeneralKnowledgeWhenNoCorpus">
                {{ 'LlmSettings.AllowGeneralKnowledge' | localize }}
              </mat-slide-toggle>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="cardWithShadow mt-4">
        <mat-card-content>
          <mat-card-header>
            <mat-card-title>{{ 'LlmSettings.ModelSettings' | localize }}</mat-card-title>
            <mat-card-subtitle>{{ 'LlmSettings.ModelSettingsDescription' | localize }}</mat-card-subtitle>
          </mat-card-header>

          <div class="row">
            <div class="col-md-12 mb-3">
              <div class="model-selection">
                <h3 class="mb-3">{{ 'LlmSettings.ModelSelections' | localize }}</h3>
                <div *ngFor="let model of availableModels" class="model-item">
                  <div class="checkbox-container">
                    <mat-checkbox
                      [(ngModel)]="model.isSelected"
                      [ngModelOptions]="{standalone: true}"
                      [disabled]="!model.enabled"
                      (change)="onModelSelectionChange(model, $event.checked)">
                      {{model.displayName}}
                      <span *ngIf="model.isDefault && model.isSelected" class="badge bg-light-primary text-primary ms-2">{{ 'LlmSettings.Default' | localize }}</span>
                    </mat-checkbox>
                  </div>
                  <small class="model-description" *ngIf="model.enabled">{{model.modelName}}</small>
                  <small class="model-disabled" *ngIf="!model.enabled">({{ 'LlmSettings.Disabled' | localize }})</small>
                </div>
              </div>
            </div>

            <div class="col-md-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'LlmSettings.DefaultModel' | localize }}</mat-label>
                <mat-select formControlName="defaultModelId" (selectionChange)="updateDefaultModelOnly($event.value)" placeholder="{{ 'LlmSettings.SelectDefaultModel' | localize }}">
                  <ng-container *ngIf="hasSelectedItems(availableModels); else noModelSelected">
                    <mat-option *ngFor="let model of getSelectedModels()"
                              [value]="model.id">
                      {{model.displayName}}
                    </mat-option>
                  </ng-container>
                  <ng-template #noModelSelected>
                    <mat-option [disabled]="true">{{ 'LlmSettings.PleaseSelectModelFirst' | localize }}</mat-option>
                  </ng-template>
                </mat-select>
                <mat-hint align="start" class="text-warning" *ngIf="missingModelDefault">
                  {{ 'LlmSettings.DefaultModelRequired' | localize }}
                </mat-hint>
                <mat-error *ngIf="settingsForm.get('defaultModelId')?.hasError('required')">
                  {{ 'LlmSettings.SelectDefaultModel' | localize }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="cardWithShadow mt-4">
        <mat-card-content>
          <mat-card-header>
            <mat-card-title>{{ 'LlmSettings.ConversationTones' | localize }}</mat-card-title>
            <mat-card-subtitle>{{ 'LlmSettings.ConversationTonesDescription' | localize }}</mat-card-subtitle>
          </mat-card-header>

          <div class="row">
            <div class="col-md-12 mb-3">
              <div class="tone-selection">
                <h3 class="mb-3">{{ 'LlmSettings.ConversationTones' | localize }}</h3>
                <div *ngFor="let tone of availableTones" class="tone-item">
                  <div class="checkbox-container">
                    <mat-checkbox
                      [(ngModel)]="tone.isSelected"
                      [ngModelOptions]="{standalone: true}"
                      (change)="onToneSelectionChange(tone, $event.checked)">
                      {{tone.name}}
                      <span *ngIf="tone.isDefault && tone.isSelected" class="badge bg-light-primary text-primary ms-2">{{ 'LlmSettings.Default' | localize }}</span>
                    </mat-checkbox>
                  </div>
                  <small class="tone-description">{{tone.description}}</small>
                </div>
              </div>
            </div>

            <div class="col-md-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'LlmSettings.DefaultTone' | localize }}</mat-label>
                <mat-select formControlName="defaultToneId" (selectionChange)="updateDefaultTone($event.value)" placeholder="{{ 'LlmSettings.SelectDefaultTone' | localize }}">
                  <ng-container *ngIf="hasSelectedItems(availableTones); else noToneSelected">
                    <mat-option *ngFor="let tone of getSelectedTones()"
                               [value]="tone.id">
                      {{tone.name}}
                    </mat-option>
                  </ng-container>
                  <ng-template #noToneSelected>
                    <mat-option [disabled]="true">{{ 'LlmSettings.PleaseSelectToneFirst' | localize }}</mat-option>
                  </ng-template>
                </mat-select>
                <mat-hint align="start" class="text-warning" *ngIf="missingToneDefault">
                  {{ 'LlmSettings.DefaultToneRequired' | localize }}
                </mat-hint>
                <mat-error *ngIf="settingsForm.get('defaultToneId')?.hasError('required')">
                  {{ 'LlmSettings.SelectDefaultTone' | localize }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="cardWithShadow mt-4">
        <mat-card-content>
          <mat-card-header>
            <mat-card-title>{{ 'LlmSettings.CreativityModes' | localize }}</mat-card-title>
            <mat-card-subtitle>{{ 'LlmSettings.CreativityModesDescription' | localize }}</mat-card-subtitle>
          </mat-card-header>

          <div class="row">
            <div class="col-md-12 mb-3">
              <div class="temperature-selection">
                <h3 class="mb-3">{{ 'LlmSettings.CreativityModes' | localize }}</h3>
                <div *ngFor="let temp of availableTemperatures" class="temperature-item">
                  <div class="checkbox-container">
                    <mat-checkbox
                      [(ngModel)]="temp.isSelected"
                      [ngModelOptions]="{standalone: true}"
                      (change)="onTemperatureSelectionChange(temp, $event.checked)">
                      {{temp.name}} ({{temp.value}})
                      <span *ngIf="temp.isDefault && temp.isSelected" class="badge bg-light-primary text-primary ms-2">{{ 'LlmSettings.Default' | localize }}</span>
                    </mat-checkbox>
                  </div>
                  <small class="temperature-description">{{temp.description}}</small>
                </div>
              </div>
            </div>

            <div class="col-md-12 mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'LlmSettings.DefaultCreativityMode' | localize }}</mat-label>
                <mat-select formControlName="defaultTemperatureId" (selectionChange)="updateDefaultTemperature($event.value)" panelClass="temperature-panel-mobile">
                  <ng-container *ngIf="hasSelectedItems(availableTemperatures); else noTempSelected">
                    <mat-option *ngFor="let temp of getSelectedTemperatures()"
                               [value]="temp.id">
                      {{temp.name}} ({{temp.value}})
                    </mat-option>
                  </ng-container>
                  <ng-template #noTempSelected>
                    <mat-option [disabled]="true">{{ 'LlmSettings.PleaseSelectCreativityModeFirst' | localize }}</mat-option>
                  </ng-template>
                </mat-select>
                <mat-hint align="start" class="text-warning" *ngIf="missingTemperatureDefault">
                  {{ 'LlmSettings.DefaultCreativityModeRequired' | localize }}
                </mat-hint>
                <mat-error *ngIf="settingsForm.get('defaultTemperatureId')?.hasError('required')">
                  {{ 'LlmSettings.SelectDefaultCreativityMode' | localize }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <div class="d-flex justify-content-start gap-2 mt-4">
        <button mat-button type="button" (click)="onCancel()" [disabled]="!hasChanges || !settingsForm.dirty">{{ 'LlmSettings.Cancel' | localize }}</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="!hasChanges || saving || !isSettingsValid || !settingsForm.dirty">
          <mat-spinner diameter="20" *ngIf="saving"></mat-spinner>
          <span *ngIf="!saving">{{ 'LlmSettings.SaveSettings' | localize }}</span>
        </button>
      </div>
    </form>
  </div>
</div>
